import { createAction, createReducer } from '@reduxjs/toolkit';
import { IAction } from './interface/apiInterfaces';
import { IDashboardData } from './interface/reduxInterfaces';

const INITIAL_STATE: IDashboardData = {
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  allClients: 0,
  totalBoletosPaid: 0,
  amountBoletosCanceled: 0,
  amountCellRecharge: 0,
  amountScheduledTranfers: 0,
  amountTedCarriedOut: 0,
  amountTedReceived: 0,
  amountUsers: 0,
  amountPartners: 0,
  boletoFaresFiduciaValue: 0,
  clFiduciaValue: 0,
  clThirdPartyValue: 0,
  clTotalValue: 0,
  fiduciaClients: 0,
  monthlyFaresFiduciaValue: 0,
  percentageBoletosPaid: 0,
  tedFaresFiduciaValue: 0,
  tedValueCarriedOut: 0,
  tedValueReceived: 0,
  totalValueBoletos: 0,
  totalValueBoletosPaid: 0,
  tevTransacted: {
    amount: 0,
    value: 0,
  },
};

export const getDashboardFromApi = createAction(
  '@dashboardApp/GET_DASHBOARD_FROM_API'
);

export const gotDashboardFromApi = createAction<any>(
  '@dashboardApp/GOT_DASHBOARD_FROM_API'
);

export const gotErrorFromDashboardApi = createAction(
  '@dashboardApp/GOT_ERROR_FROM_DASHBOARD_API'
);

const dashboardAppReducer = createReducer(INITIAL_STATE, {
  [getDashboardFromApi.type]: (state) => ({
    ...state,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [gotDashboardFromApi.type]: (state, action: IAction) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    totalBoletosPaid: action.payload.qtd_pagamento_boleto,
    amountBoletosCanceled: action.payload.total_boletos_cancelados,
    amountCellRecharge: action.payload.qtd_recarga_celular,
    amountScheduledTranfers: action.payload.qtd_transf_agendadas,
    amountTedCarriedOut: action.payload.ted_realizadas,
    amountTedReceived: action.payload.ted_recebidas,
    amountUsers: action.payload.qtd_usuarios,
    amountPartners: action.payload.qtd_parceiros,
    boletoFaresFiduciaValue: action.payload.valor_tarifa_boleto_fiducia,
    clFiduciaValue: action.payload.valor_cl_conta_fiducia,
    clThirdPartyValue: action.payload.valor_cl_terceiro,
    clTotalValue: action.payload.valor_cl,
    fiduciaClients: action.payload.fiducia_clientes,
    allClients: action.payload.todos_clientes,
    monthlyFaresFiduciaValue: action.payload.valor_tarifa_mensal_fiducia,
    percentageBoletosPaid: action.payload.porc_boletos_liquidados,
    tedFaresFiduciaValue: action.payload.valor_tarifa_ted_fiducia,
    tedValueCarriedOut: action.payload.valor_ted_realizadas,
    tedValueReceived: action.payload.valor_ted_recebidas,
    totalValueBoletos: action.payload.total_boletos,
    totalValueBoletosPaid: action.payload.total_boletos_liquidados,
    tevTransacted: {
      amount: action.payload.valor_tev_movimentas[0].qtd,
      value: action.payload.valor_tev_movimentas[0].valor,
    },
  }),
  [gotErrorFromDashboardApi.type]: (state) => ({
    ...state,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
});

export default dashboardAppReducer;
